import { Api } from 'models/services/api';
import { ReadBrandsQuery } from 'models/services/graphql';

import { BrandCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query ReadBrands($nextToken: String) {
    ${ReadBrandsQuery}
  }
`;

type ResponseData = {
  data: {
    readBrands: BrandCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: BrandCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readBrands;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
